/**
 * AttributionTracker
 *
 * Invisible component mounted once inside <BrowserRouter>. On initial load and
 * on every navigation it captures ad click-ids / UTM params from the URL into
 * the first-party `_first_party_attribution` cookie.
 *
 * It renders nothing and does not interfere with the existing GA4/GTM tags.
 */

import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { captureAttributionFromParams } from '@/lib/attribution';

export default function AttributionTracker(): null {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Merge the current URL params into the persistent attribution cookie.
    // captureAttributionFromParams never overwrites saved values with nulls,
    // so internal navigation (no UTMs) preserves the original campaign data.
    captureAttributionFromParams(searchParams);
  }, [searchParams]);

  return null;
}
